import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterToolbar = ({
  searchQuery,
  onSearchChange,
  selectedCourse,
  onCourseChange,
  selectedLocation,
  onLocationChange,
  selectedCategory,
  onCategoryChange,
  selectedStatus,
  onStatusChange,
  resultCount,
  onClearFilters,
  isMobileFilterOpen,
  onToggleMobileFilter
}) => {
  const courseOptions = [
    { value: 'all', label: 'All Courses' },
    { value: 'engineering', label: 'Engineering' },
    { value: 'medical', label: 'Medical' },
    { value: 'management', label: 'Management' },
    { value: 'arts', label: 'Arts & Humanities' },
    { value: 'science', label: 'Science' },
    { value: 'commerce', label: 'Commerce' },
    { value: 'law', label: 'Law' },
    { value: 'design', label: 'Design' }
  ];

  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    // Tier 1 Cities
    { value: 'delhi', label: 'Delhi NCR' },
    { value: 'mumbai', label: 'Mumbai' },
    { value: 'bangalore', label: 'Bangalore' },
    { value: 'hyderabad', label: 'Hyderabad' },
    { value: 'pune', label: 'Pune' },
    { value: 'chennai', label: 'Chennai' },
    { value: 'kolkata', label: 'Kolkata' },
    { value: 'ahmedabad', label: 'Ahmedabad' },
    // Tier 2 Cities - North
    { value: 'chandigarh', label: 'Chandigarh' },
    { value: 'jaipur', label: 'Jaipur' },
    { value: 'lucknow', label: 'Lucknow' },
    { value: 'kanpur', label: 'Kanpur' },
    { value: 'nagpur', label: 'Nagpur' },
    { value: 'indore', label: 'Indore' },
    { value: 'bhopal', label: 'Bhopal' },
    { value: 'ludhiana', label: 'Ludhiana' },
    { value: 'agra', label: 'Agra' },
    { value: 'varanasi', label: 'Varanasi' },
    { value: 'amritsar', label: 'Amritsar' },
    { value: 'allahabad', label: 'Prayagraj (Allahabad)' },
    { value: 'meerut', label: 'Meerut' },
    { value: 'jabalpur', label: 'Jabalpur' },
    { value: 'gwalior', label: 'Gwalior' },
    { value: 'dehradun', label: 'Dehradun' },
    // Tier 2 Cities - South
    { value: 'coimbatore', label: 'Coimbatore' },
    { value: 'kochi', label: 'Kochi' },
    { value: 'thiruvananthapuram', label: 'Thiruvananthapuram' },
    { value: 'mysore', label: 'Mysore' },
    { value: 'mangalore', label: 'Mangalore' },
    { value: 'vijayawada', label: 'Vijayawada' },
    { value: 'visakhapatnam', label: 'Visakhapatnam' },
    { value: 'madurai', label: 'Madurai' },
    { value: 'tiruchirappalli', label: 'Tiruchirappalli' },
    { value: 'salem', label: 'Salem' },
    { value: 'tirupati', label: 'Tirupati' },
    { value: 'warangal', label: 'Warangal' },
    // Tier 2 Cities - East
    { value: 'bhubaneswar', label: 'Bhubaneswar' },
    { value: 'patna', label: 'Patna' },
    { value: 'ranchi', label: 'Ranchi' },
    { value: 'guwahati', label: 'Guwahati' },
    { value: 'raipur', label: 'Raipur' },
    { value: 'cuttack', label: 'Cuttack' },
    // Tier 2 Cities - West
    { value: 'surat', label: 'Surat' },
    { value: 'vadodara', label: 'Vadodara' },
    { value: 'rajkot', label: 'Rajkot' },
    { value: 'nashik', label: 'Nashik' },
    { value: 'aurangabad', label: 'Aurangabad' },
    { value: 'thane', label: 'Thane' },
    { value: 'navi-mumbai', label: 'Navi Mumbai' },
    // Tier 3 Cities - North
    { value: 'jodhpur', label: 'Jodhpur' },
    { value: 'kota', label: 'Kota' },
    { value: 'ajmer', label: 'Ajmer' },
    { value: 'udaipur', label: 'Udaipur' },
    { value: 'bikaner', label: 'Bikaner' },
    { value: 'aligarh', label: 'Aligarh' },
    { value: 'moradabad', label: 'Moradabad' },
    { value: 'saharanpur', label: 'Saharanpur' },
    { value: 'gorakhpur', label: 'Gorakhpur' },
    { value: 'bareilly', label: 'Bareilly' },
    { value: 'mathura', label: 'Mathura' },
    { value: 'firozabad', label: 'Firozabad' },
    { value: 'jhansi', label: 'Jhansi' },
    { value: 'rohtak', label: 'Rohtak' },
    { value: 'panipat', label: 'Panipat' },
    { value: 'karnal', label: 'Karnal' },
    { value: 'ambala', label: 'Ambala' },
    { value: 'patiala', label: 'Patiala' },
    { value: 'jalandhar', label: 'Jalandhar' },
    { value: 'bathinda', label: 'Bathinda' },
    { value: 'hoshiarpur', label: 'Hoshiarpur' },
    { value: 'shimla', label: 'Shimla' },
    { value: 'jammu', label: 'Jammu' },
    { value: 'srinagar', label: 'Srinagar' },
    // Tier 3 Cities - South
    { value: 'vellore', label: 'Vellore' },
    { value: 'erode', label: 'Erode' },
    { value: 'tirunelveli', label: 'Tirunelveli' },
    { value: 'thanjavur', label: 'Thanjavur' },
    { value: 'dindigul', label: 'Dindigul' },
    { value: 'kurnool', label: 'Kurnool' },
    { value: 'nellore', label: 'Nellore' },
    { value: 'guntur', label: 'Guntur' },
    { value: 'kakinada', label: 'Kakinada' },
    { value: 'rajahmundry', label: 'Rajahmundry' },
    { value: 'belgaum', label: 'Belgaum' },
    { value: 'hubli', label: 'Hubli' },
    { value: 'gulbarga', label: 'Gulbarga' },
    { value: 'bellary', label: 'Bellary' },
    { value: 'tumkur', label: 'Tumkur' },
    { value: 'davangere', label: 'Davangere' },
    { value: 'shimoga', label: 'Shimoga' },
    { value: 'kollam', label: 'Kollam' },
    { value: 'thrissur', label: 'Thrissur' },
    { value: 'kannur', label: 'Kannur' },
    { value: 'kozhikode', label: 'Kozhikode' },
    { value: 'palakkad', label: 'Palakkad' },
    { value: 'alappuzha', label: 'Alappuzha' },
    // Tier 3 Cities - East
    { value: 'jamshedpur', label: 'Jamshedpur' },
    { value: 'dhanbad', label: 'Dhanbad' },
    { value: 'bokaro', label: 'Bokaro' },
    { value: 'durgapur', label: 'Durgapur' },
    { value: 'asansol', label: 'Asansol' },
    { value: 'siliguri', label: 'Siliguri' },
    { value: 'muzaffarpur', label: 'Muzaffarpur' },
    { value: 'bhagalpur', label: 'Bhagalpur' },
    { value: 'purnia', label: 'Purnia' },
    { value: 'darbhanga', label: 'Darbhanga' },
    { value: 'gaya', label: 'Gaya' },
    { value: 'sambalpur', label: 'Sambalpur' },
    { value: 'rourkela', label: 'Rourkela' },
    { value: 'berhampur', label: 'Berhampur' },
    { value: 'shillong', label: 'Shillong' },
    { value: 'imphal', label: 'Imphal' },
    { value: 'agartala', label: 'Agartala' },
    { value: 'aizawl', label: 'Aizawl' },
    { value: 'dibrugarh', label: 'Dibrugarh' },
    { value: 'silchar', label: 'Silchar' },
    { value: 'tezpur', label: 'Tezpur' },
    { value: 'jorhat', label: 'Jorhat' },
    // Tier 3 Cities - West
    { value: 'bhavnagar', label: 'Bhavnagar' },
    { value: 'jamnagar', label: 'Jamnagar' },
    { value: 'junagadh', label: 'Junagadh' },
    { value: 'gandhinagar', label: 'Gandhinagar' },
    { value: 'anand', label: 'Anand' },
    { value: 'mehsana', label: 'Mehsana' },
    { value: 'nadiad', label: 'Nadiad' },
    { value: 'valsad', label: 'Valsad' },
    { value: 'kolhapur', label: 'Kolhapur' },
    { value: 'sangli', label: 'Sangli' },
    { value: 'solapur', label: 'Solapur' },
    { value: 'ahmednagar', label: 'Ahmednagar' },
    { value: 'jalgaon', label: 'Jalgaon' },
    { value: 'akola', label: 'Akola' },
    { value: 'latur', label: 'Latur' },
    { value: 'nanded', label: 'Nanded' },
    { value: 'amravati', label: 'Amravati' },
    { value: 'ichalkaranji', label: 'Ichalkaranji' },
    // Central India
    { value: 'ujjain', label: 'Ujjain' },
    { value: 'sagar', label: 'Sagar' },
    { value: 'dewas', label: 'Dewas' },
    { value: 'satna', label: 'Satna' },
    { value: 'ratlam', label: 'Ratlam' },
    { value: 'rewa', label: 'Rewa' },
    { value: 'katni', label: 'Katni' },
    { value: 'singrauli', label: 'Singrauli' },
    { value: 'bilaspur', label: 'Bilaspur' },
    { value: 'korba', label: 'Korba' },
    { value: 'durg', label: 'Durg' },
    { value: 'bhilai', label: 'Bhilai' },
    { value: 'rajnandgaon', label: 'Rajnandgaon' },
    // Option for custom location
    { value: 'other', label: 'Other (Type to search or specify)' }
  ];

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'university', label: 'University' },
    { value: 'college', label: 'College' },
    { value: 'institute', label: 'Institute' },
    { value: 'academy', label: 'Academy' },
    { value: 'school', label: 'B-School' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'live', label: 'Live Now' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'offline', label: 'Offline' }
  ];

  const hasActiveFilters = selectedCourse !== 'all' || selectedLocation !== 'all' || 
                          selectedCategory !== 'all' || selectedStatus !== 'all' || searchQuery;

  return (
    <>
      <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 mb-4 md:mb-6">
        <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
          <div className="flex-1">
            <Input
              type="search"
              placeholder="Search institutes by name, course, or location..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full"
            />
          </div>
          <Button
            variant="outline"
            iconName="SlidersHorizontal"
            iconPosition="left"
            onClick={onToggleMobileFilter}
            className="lg:hidden"
          >
            Filters
            {hasActiveFilters && (
              <span className="ml-2 w-2 h-2 bg-accent rounded-full" />
            )}
          </Button>
        </div>

        <div className={`${isMobileFilterOpen ? 'block' : 'hidden'} lg:block mt-4 md:mt-5`}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            <Select
              label="Course Type"
              options={courseOptions}
              value={selectedCourse}
              onChange={onCourseChange}
              searchable
            />
            <Select
              label="Location"
              options={locationOptions}
              value={selectedLocation}
              onChange={onLocationChange}
              searchable
            />
            <Select
              label="Institute Category"
              options={categoryOptions}
              value={selectedCategory}
              onChange={onCategoryChange}
            />
            <Select
              label="Booth Status"
              options={statusOptions}
              value={selectedStatus}
              onChange={onStatusChange}
            />
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mt-4 md:mt-5 pt-4 md:pt-5 border-t border-border">
            <div className="flex items-center gap-2">
              <Icon name="Search" size={18} color="var(--color-primary)" />
              <span className="text-sm md:text-base text-foreground">
                <span className="font-semibold data-text">{resultCount}</span> institutes found
              </span>
            </div>
            {hasActiveFilters && (
              <Button
                variant="ghost"
                size="sm"
                iconName="X"
                iconPosition="left"
                onClick={onClearFilters}
              >
                Clear Filters
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterToolbar;